import React from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import { COLLAPSED_NAVBAR_HEIGHT } from 'styles/globals';
import PoweredBy5app from 'components/PoweredBy5app';
import { SkipNavigationLink, SkipNavigationTarget } from 'components/SkipNavigationLink';
import GlobalModals from './modals/globalModals';
import NewNavigation, { NewPageWrapper } from './navigation/NewNavigation';
import OldNavigation, { PageWrapper as OldPageWrapper } from './navigation';
import AssetViewer from './assetViewer';
import AlertRenderer from './alertRenderer';
import FloatingContactButton from './FloatingContactButton';
import WebAppInstallPrompt from './webAppInstallPrompt';
import HubErrorBoundary from '../pages/errors/HubErrorBoundary';
import { useAuthContext } from '../contexts/auth';
var Navigation = config.newNavigationBar ? NewNavigation : OldNavigation;
var PageWrapper = config.newNavigationBar ? NewPageWrapper : OldPageWrapper;
function Page(_ref) {
  var children = _ref.children;
  var _useAuthContext = useAuthContext(),
    authUser = _useAuthContext.authUser;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!authUser) {
    return null;
  }
  return /*#__PURE__*/React.createElement(PageWrapper, null, /*#__PURE__*/React.createElement(HubErrorBoundary, null, /*#__PURE__*/React.createElement(SkipNavigationLink, null, t('actions_skip_navigation')), /*#__PURE__*/React.createElement(Navigation, null), /*#__PURE__*/React.createElement(SkipNavigationTarget, {
    verticalOffset: COLLAPSED_NAVBAR_HEIGHT
  }), /*#__PURE__*/React.createElement(AssetViewer, null), /*#__PURE__*/React.createElement("main", null, children, config.floatingContactButton && /*#__PURE__*/React.createElement(FloatingContactButton, null)), /*#__PURE__*/React.createElement(GlobalModals, null), /*#__PURE__*/React.createElement(PoweredBy5app, null), /*#__PURE__*/React.createElement(WebAppInstallPrompt, null), /*#__PURE__*/React.createElement(AlertRenderer, null)));
}
export default Page;